// src/index.jsx
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Ability } from "@casl/ability";

import App from "./App";
import { MaterialUIControllerProvider, AuthContextProvider } from "./context";
import { AbilityContext } from "./Can";  // Göreli yol

const container = document.getElementById("root");
const root = createRoot(container);

// Başlangıçta boş bir Ability
const ability = new Ability();

root.render(
    <AbilityContext.Provider value={ability}>
        <BrowserRouter>
            <AuthContextProvider>
                <MaterialUIControllerProvider>
                    <App />  {/* Artık prop yok; context’ten alıyor */}
                </MaterialUIControllerProvider>
            </AuthContextProvider>
        </BrowserRouter>
    </AbilityContext.Provider>
);
